import { useState } from 'react'
import './DeleteRunConfirmation.css'

interface DeleteRunConfirmationProps {
  runId: string
  onConfirm: () => void
}

function DeleteRunConfirmation({ runId, onConfirm }: DeleteRunConfirmationProps) {
  const [showConfirm, setShowConfirm] = useState(false)

  function handleConfirm() {
    onConfirm()
    setShowConfirm(false)
  }

  return (
    <div className="delete-run-wrapper">
      <button
        data-testid={`delete-run-${runId}`}
        className="delete-run-btn"
        onClick={() => setShowConfirm(!showConfirm)}
        title="Delete this run?"
      >
        <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M2 4h12M5.33 4V2.67a1.33 1.33 0 011.34-1.34h2.66a1.33 1.33 0 011.34 1.34V4M12.67 4v9.33a1.33 1.33 0 01-1.34 1.34H4.67a1.33 1.33 0 01-1.34-1.34V4" /></svg>
      </button>
      {showConfirm && (
        <div data-testid={`delete-run-confirm-${runId}`} className="delete-run-popover">
          <div className="delete-run-popover-title">Delete this run?</div>
          <div className="delete-run-popover-actions">
            <button
              data-testid={`confirm-delete-run-${runId}`}
              className="delete-run-confirm-yes"
              onClick={handleConfirm}
            >
              Delete
            </button>
            <button
              data-testid={`cancel-delete-run-${runId}`}
              className="delete-run-confirm-no"
              onClick={() => setShowConfirm(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default DeleteRunConfirmation
